import React, { FC } from "react";

import { PopUpContainer } from "../BookingLegacy/FormElements/PopUps/PopUpContainer";
import { ModalViewModel } from "../../Blocks/PopUp/ModalViewModel.csharp";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";
import { Button } from '../Booking/Button/Button';

type AppointmentDetailsConfirmationProps = {
  Modal: any;
  isOpen: boolean;
  modalContent: ModalViewModel;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
};

export const AppointmentCancellationConfirmationModal: FC<AppointmentDetailsConfirmationProps> =
  ({ Modal, isOpen, modalContent, onClose, onSubmit, isLoading }) => {
    return (
      <PopUpContainer
        Modal={Modal}
        isOpen={isOpen}
        handleCloseButtonClick={onClose}
        isNewBooking={true}
      >
        <h4>{modalContent.header}</h4>
        <div
          className="mb-3"
          dangerouslySetInnerHTML={{ __html: modalContent.description }}
        />
        <div className="d-flex justify-content-center flex-column gap-3">
          <Button
            disabled={isLoading}
            onClick={onSubmit}
            variant='primary'
            size='large'
          >
            {isLoading ? (
              <LoadingAnimation text={modalContent.secondButton.link.title} />
            ) : (
              modalContent.secondButton.link.title
            )}
          </Button>

          <Button onClick={onClose} variant='secondary' size='large'>
            {modalContent.button.link.title}
          </Button>
        </div>
      </PopUpContainer>
    );
  };
